import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#auto-wrapping" }),
  /*#__PURE__*/_createTextVNode(" Auto wrapping ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" When in horizontal mode, using "),
  /*#__PURE__*/_createVNode("code", null, "wrap"),
  /*#__PURE__*/_createTextVNode(" (bool type) to control auto wrapping behavior. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Text button ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_space = _resolveComponent("el-space")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_space, { wrap: "" }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(20, (i) => {
            return _createVNode("div", { key: i }, [
              _createVNode(_component_el_button, { type: "text" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ])
          }), 64))
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}